/* eslint-disable max-len -- HTML e-mail templates; line breaks inside them would change the rendered e-mails */
const RULE_1 = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>Dear &lt;investmentFirstName&gt;,</p>
            </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>Thank you for creating your True Impact report for &lt;donorAccountName&gt;. Please complete and submit for
                    review by &lt;submitForFeedback&gt;.</p>
                <p>If you have any questions about the impact reporting process, don't hesitate to get in touch with our
                    measurement specialists at <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>, or access resources at support.trueimpact.com. We’re
                    here to help!</p>
                <p>Sincerely,</p>
                <p><b>&lt;projectManager&gt;</b></p>
                <br />
                <p>Reporting schedule:</p>
                <ul>
                    <li>&lt;submitForFeedback&gt;: Submit your draft report</li>
                    <li>A week later you'll receive feedback from True Impact</li>
                    <li>&lt;resolveFeedback&gt;: Publish your updated report to &lt;donorAccountName&gt;</li>
                    <li>&lt;interimReportUpdate&gt;: Return to your report to set the stage to Interim and submit an updated forecast.</li>
                    <li>&lt;finalizeReportDate&gt;: Return to your report to set the stage to Final and submit actuals.</li>
                </ul>
                <br />
                <p><b>Tips + tricks</b></p>
                <ul>
                    <li><b>Report stage</b> // When selecting your report stage, keep in mind:</li>
                    <ul>
                        <li><b>Initial:</b> means you are just starting implementation of your program and will forecast
                            final results</li>
                        <li><b>Interim:</b> means you are already underway implementing your program and will forecast
                            final results </li>
                        <li><b>Final:</b> your program has already finished and you'll be reporting final results</li>
                    </ul>
                    <li><b>Reporting period</b> // For most folks, we are hoping that a one year report period will work
                        well. If your program is 18 months long, please create an 18 month report. If your program is
                        multiple years, please try to select a one year reporting period. If you may not see social impacts
                        in year 1 of a multiple year program, send me a quick email and we can discuss options. It is very
                        important to remember that everything in your report should match to your reporting period including
                        the budget, values forecasted for indicators, etc. </li>
                    <li><b>Impact model stages</b> // Recall, only Reach + Succeed are required staged. Program Development,
                        Learn, and Act are optional and should be used if they make sense to your model. Program development
                        means internal efforts such as hiring/training staff, creating new curriculum, purchasing new
                        resources, etc. Note that we recently updated language in the True Impact platform to change
                        “Capacity Developed” to “Program Development” in order to more accurately capture the purpose of the
                        stage. “Capacity Developed” is still noted in all of your training materials, but know that they
                        mean the same thing. </li>
                    <li><b>Measurement category</b> // Please keep in mind that for all Initial and Interim reports you are
                        *forecasting* your social impacts. These are inherently assumed to be educated guesses/forecasts.
                        When you're asked to select the measurement category, we're asking how you will know the values by
                        the time the report period ends: guess, estimate, or directly measure? Then, it will ask you to
                        briefly tell us more about how you're estimating, or measuring. So if you're guessing a value today
                        but will be able to measure it at the end of the report period, you'd want to select Directly
                        Measured.</li>
                    <li><b>Budget</b> // Please include all expenses for your reporting period, which may include funders
                        beyond &lt;donorAccountName&gt;. This section is meant to capture the full costs to run the program
                        during the reporting period indicated.</li>
                </ul>
            </div>
        </td>
    </tr>
`;

const RULE_3 = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>Dear &lt;donorAccountName&gt; Partners,</p>
        </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>I wanted to send along a quick note to thank you for submitting the following True Impact report for review:</p>
            <ul>
                <li>Organization: &lt;investmentRecipientOrganization&gt;</li>
                <li>Program: &lt;investmentFundedProgramName&gt;</li>
                <li>Investment: $&lt;investmentAmount&gt;</li>
                <li>Account email: &lt;investmentRecipientEmail&gt;</li>
            </ul>
            <br/>
            <p>I'm very much looking forward to reviewing it.</p>
            <p>As I review each report, you will receive an automated email from the True Impact system when your report feedback is ready for review (this email will go to the main TI platform contact). Your feedback will be ready for you to review and resolve feedback, and submit your updated report by &lt;resolveFeedback&gt;. <a href="https://support.trueimpact.com/how-do-i-resolve-feedback-on-my-social-impact-report">This article provides guidance on how to resolve feedback in the True Impact system.</a></p>
            <br/>
            <p>If you have any questions as you receive your feedback, please don't hesitate to reach out to me. </p>
            <p>Best wishes,</p>
            <p><b>&lt;projectManager&gt;</b></p>
            <br/>
            <p>Reporting schedule:</p>
            <ul>
                <li>&lt;submitForFeedback&gt;: Submit your draft report</li>
                <li>Two weeks later, you'll receive feedback from True Impact</li>
                <li>&lt;resolveFeedback&gt;: Publish your updated report to &lt;donorAccountName&gt;</li>
            </ul>
        </div>
        </td>
    </tr>
`;

const RULE_4 = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>Dear &lt;investmentFirstName&gt;,</p>
        </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>Thank you for beginning your initial forecast report for &lt;donorAccountName&gt; for the following investment:</p>
            <ul>
                <li>Organization: &lt;investmentRecipientOrganization&gt;</li>
                <li>Program: &lt;investmentFundedProgramName&gt;</li>
                <li>Investment: $&lt;investmentAmount&gt;</li>
                <li>Account email: &lt;investmentRecipientEmail&gt;</li>
            </ul>
            <br/>
            <p><b>A few considerations for Initial Forecasts:</b></p>
            <ul>
                <li><b>Initial Forecasts</b> // Means you are just starting implementation of your program and will report on your expected outcomes</li>
                <li><b>Reporting period</b> // If your program is multiple years, please try to select a one year reporting period. If you may not see social impacts in year 1 of a multiple year program, that’s fine - represent your program implementation in the start and end dates, and the full impacts of the program in the Outcomes section.</li>
                <li><b>Measurement category</b> // Please keep in mind that for all Initial and Interim reports you are *forecasting* your social impacts. These are inherently assumed to be educated guesses/forecasts. When you’re asked to select the measurement category, we’re asking how you will know the values by the time the report period ends: guess, estimate, or directly measure? Then, it will ask you to briefly tell us more about how you’re estimating, or measuring. So if you’re guessing a value today but will be able to measure it at the end of the report period, you’d want to select Directly Measured.</li>
                <li><b>Budget</b> // Please include all expected expenses for your reporting period, which may include funding beyond &lt;donorAccountName&gt;. This section is meant to capture the full costs to run the program during the reporting period indicated.</li>
            </ul>
            <br/>
            <p>Log into your account at login.trueimpact.com. Additional guidance is here https://support.trueimpact.com/getting-started-with-true-impact</p>
            <p>If you have any questions about the impact reporting process, don't hesitate to get in touch with our measurement specialists at <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>, or access resources at support.trueimpact.com. We’re here to help.</p>
            <p>Sincerely,</p>
            <p><b>&lt;projectManager&gt;</b></p>
        </div>
        </td>
    </tr>
`;

const RULE_5 = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>Dear &lt;investmentFirstName&gt;,</p>
            </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>This is a gentle reminder that action is required on your report for &lt;donorAccountName&gt;.</p>
                <p>Please report on your program's anticipated or actual outcomes for the following investment:</p>
                <ul>
                    <li>Organization: &lt;investmentRecipientOrganization&gt;</li>
                    <li>Program: &lt;investmentFundedProgramName&gt;</li>
                    <li>Investment: $&lt;investmentAmount&gt;</li>
                    <li>Account email: &lt;investmentRecipientEmail&gt;</li>
                </ul>
                <br />
                <p>If your status is:</p>
                <ul>
                    <li><b>Waiting.</b> Accept the investment and allocate it to a new or existing report</li>
                    <li><b>Draft.</b> Submit completed report for review</li>
                    <li><b>TI Feedback Provided.</b> Resolve feedback and submit for verification</li>
                    <li><b>Awaiting Funder Feedback.</b> Contact your relationship manager for report feedback</li>
                    <li><b>Funder Feedback Provided.</b> Resolve feedback and submit for verification</li>
                    <li><b>Awaiting Funder Verification.</b> Contact your relationship manager to verify and publish your
                        report</li>
                    <li><b>Published.</b> Update with final results upon program completion</li>
                </ul>
                <br />
                <p>Log into your account at login.trueimpact.com, or create a new True Impact reporting account at
                    www.trueimpact.com/signup. Additional guidance is here
                    https://support.trueimpact.com/getting-started-with-true-impact</p>
                <p>If you have any questions about the impact reporting process, don't hesitate to get in touch with our
                    measurement specialists at <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>, or access resources at support.trueimpact.com. We're
                    here to help.</p>
                <p>Sincerely,</p>
                <p><b>&lt;projectManager&gt;</b></p>
                <br />
                <p>Reporting schedule:</p>
                <p>&lt;submitForFeedback&gt;: Submit your draft report</p>
                <p>A week later you'll receive feedback from True Impact</p>
                <p>&lt;resolveFeedback&gt;: Publish your updated report to &lt;donorAccountName&gt;</p>
                <p>&lt;interimReportUpdate&gt;: Return to your report to set the stage to Interim and submit an updated forecast.</p>
                <p>&lt;finalizeReportDate&gt;: Return to your report to set the stage to Final and submit actuals.</p>
                <br />
                <p><b>Tips + tricks</b></p>
                <ul>
                    <li><b>Report stage</b> // When selecting your report stage, keep in mind:</li>
                    <ul>
                        <li><b>Initial:</b> means you are just starting implementation of your program and will forecast
                            final results</li>
                        <li><b>Interim:</b> means you are already underway implementing your program and will forecast
                            final results </li>
                        <li><b>Final:</b> your program has already finished and you'll be reporting final results</li>
                    </ul>
                    <li><b>Reporting period</b> // For most folks, we are hoping that a one year report period will work
                        well. If your program is 18 months long, please create an 18 month report. If your program is
                        multiple years, please try to select a one year reporting period. If you may not see social impacts
                        in year 1 of a multiple year program, send me a quick email and we can discuss options. It is very
                        important to remember that everything in your report should match to your reporting period including
                        the budget, values forecasted for indicators, etc. </li>
                    <li><b>Impact model stages</b> // Recall, only Reach + Succeed are required staged. Program Development,
                        Learn, and Act are optional and should be used if they make sense to your model. Program development
                        means internal efforts such as hiring/training staff, creating new curriculum, purchasing new
                        resources, etc. Note that we recently updated language in the True Impact platform to change
                        “Capacity Developed” to “Program Development” in order to more accurately capture the purpose of the
                        stage. “Capacity Developed” is still noted in all of your training materials, but know that they
                        mean the same thing. </li>
                    <li><b>Measurement category</b> // Please keep in mind that for all Initial and Interim reports you are
                        *forecasting* your social impacts. These are inherently assumed to be educated guesses/forecasts.
                        When you're asked to select the measurement category, we're asking how you will know the values by
                        the time the report period ends: guess, estimate, or directly measure? Then, it will ask you to
                        briefly tell us more about how you're estimating, or measuring. So if you're guessing a value today
                        but will be able to measure it at the end of the report period, you'd want to select Directly
                        Measured.</li>
                    <li><b>Budgetz</b> // Please include all expenses for your reporting period, which may include funders
                        beyond &lt;donorAccountName&gt;. This section is meant to capture the full costs to run the program
                        during the reporting period indicated.</li>
                </ul>
            </div>
        </td>
    </tr>
`;

const RULE_6 = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>Dear &lt;investmentFirstName&gt;,</p>
        </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>I'm <b>&lt;projectManager&gt;</b> from True Impact. It's great to meet you!</p>
            <p>We're working with &lt;donorAccountName&gt; to better share your impacts through our web-based reporting platform. This is your invitation to create an account at www.trueimpact.com/signup, or log into your existing account at www.trueimpact.com/login.</p>
            <p>Please report on your program's anticipated or actual outcomes for the following investment:</p>
            <p>Organization: &lt;investmentRecipientOrganization&gt;</p>
            <p>Program: &lt;investmentFundedProgramName&gt;</p>
            <p>Investment: $&lt;investmentAmount&gt;</p>
            <p>Account email: &lt;investmentRecipientEmail&gt;</p>
            <p><b>Step One: Initial Social Impact Report</b></p>
            <ul>
                <li>Please register with this link for our training on how to complete your Social Impact Report. If you can't make it, no worries. All resources, guides, and training decks are on our support pages.</li>
                <li>Create a new True Impact reporting account at www.trueimpact.com/signup to accept the investment and create a new report.</li>
                <li>Submit your initial report by &lt;submitForFeedback&gt;. This initial report will be a forecast of your anticipated outcomes. When projecting your outcomes, you will be asked to define both your outcome goals and your measurement plans to track progress towards those goals. These initial outcome projections will be saved in your report as a forecast.</li>
                <li>Within approximately one week of submitting your draft Initial Report, you will receive feedback on your forecast from True Impact.</li>
                <li>Upon receipt of our feedback, you'll have until &lt;resolveFeedback&gt; to update your initial report. Once you’ve updated your initial report with our feedback, your initial report will be shared with &lt;donorAccountName&gt;</li>
                <li></li>
            </ul>
            <p><b>Step Two: Final Social Impact Report</b></p>
            <ul>
                <li>On &lt;finalizeReportDate&gt;, update your initial report with final results. This update will be your final report.</li>
                <li>If you have any questions during the final reporting process, I'm here to help.</li>
                <li>All Social Impact reports will be shared with &lt;donorAccountName&gt;.</li>
            </ul>
            <p>If you get stuck, you can watch the training and download the training deck here: https://support.trueimpact.com/creating-a-report.</p>
            <p>And if you have questions and would like to have a quick call, please email <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>. I’m here to help!</p>
            <p>Best wishes,</p>
            <p><b>&lt;projectManager&gt;</b></p>
            <p><b>Quick tips:</b></p>
            <ul>
                <li><b>Best available data approach:</b> This reporting process is not a mandate to collect new information or redesign the program to ensure specific outcomes. True Impact's reporting asks you to use the information you already collect or plan to collect to tell your program's story of impact. If you don't directly measure certain outcomes, that's just fine. You should include the outcomes that matter most to your program whether or not you can directly measure those outcomes (in the report you can note that you're estimating or guessing those outcomes if you don't directly measure them.)</li>
                <li><b>You know your theory of change!</b> Our reporting process helps you generate an executive summary of your program. The theory of change you detail in the report should align with what you already know your program's mission and impact to be. In all likelihood, you have told your program's story before in the form of proposals and/or annual reports. The True Impact report captures and amplifies this story. While we do ask that you clearly define success and measurement details at each stage of your theory of change, your high-level story of how your program improves lives or contributes to society is something I'm sure all partners are equipped to communicate well and that's exactly what you'll want to represent in the Outcomes section. You know your story and the True Impact reporting process allows you to lift up that story and share it with your stakeholders.</li>
            </ul>
        </div>
        </td>
    </tr>
`;

const RULE_7 = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>&lt;investmentFirstName&gt;,</p>
            </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>Thanks for allocating your &lt;donorAccountName&gt; investment of &lt;investmentAmount&gt; to the report
                    &lt;investmentFundedProgramName&gt;.</p>
                <p>If you have any questions about the impact reporting process, don't hesitate to get in touch with us at <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>, or access resources at support.trueimpact.com.</p>
                <p>Sincerely,</p>
                <p><b>&lt;projectManager&gt;</b></p>
                <p>Reporting schedule:</p>
                <p>&lt;submitForFeedback&gt;: Submit your draft report</p>
                <p>A week later you'll receive feedback from True Impact</p>
                <p>&lt;resolveFeedback&gt;: Publish your updated report to &lt;donorAccountName&gt;</p>
                <p>&lt;interimReportUpdate&gt;: Return to your report to set the stage to Interim and submit an updated forecast.</p>
                <p>&lt;finalizeReportDate&gt;: Return to your report to set the stage to Final and submit actuals.</p>
            </div>
        </td>
    </tr>
`;

const RULE_8 = RULE_3;

const RULE_9 = RULE_4;

const RULE_14 = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>Dear &lt;investmentFirstName&gt;,</p>
            </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>Your investment invitation was sent.</p>
                <p>If you have any questions about the impact reporting process, don't hesitate to get in touch with us at <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>, or access resources at support.trueimpact.com.</p>
                <p>Sincerely,</p>
                <p><b>&lt;projectManager&gt;</b></p>
            </div>
        </td>
    </tr>
`;

const TEMPLATES = {
    RULE_1,
    RULE_3,
    RULE_4,
    RULE_5,
    RULE_6,
    RULE_7,
    RULE_8,
    RULE_9,
    RULE_14
};

const RULE_8_STATUS_DRAFT = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>Dear &lt;investmentFirstName&gt;,</p>
        </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>Thank you for creating your True Impact report for &lt;donorAccountName&gt;. Please complete and submit for review by &lt;submitForFeedback&gt;.</p>
            <p>If you have any questions about the impact reporting process, don't hesitate to get in touch with our measurement specialists at <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>, or access resources at support.trueimpact.com. We’re here to help!</p>
            <p>Sincerely,</p>
            <p><b>The True Impact team</b></p>
            <br/>
            <p>Reporting schedule:</p>
            <ul>
                <li>&lt;submitForFeedback&gt;: Submit your draft report</li>
                <li>Two weeks later, you'll receive feedback from True Impact</li>
                <li>&lt;resolveFeedback&gt;: Publish your updated report to &lt;donorAccountName&gt;</li>
                <li>&lt;finalizeReportDate&gt;: Return to your report to set the stage to Final and submit actuals.</li>
            </ul>
            <br/>
            <p><b>Tips + tricks</b></p>
            <ul>
                <li><b>Works in progress</b> // You can create a Social Impact report even if your program period isn't complete. You would create an Interim or Initial report to forecast out your anticipated impacts.</li>
                <li><b>Clone past reports</b> // If you've already reported via True Impact, you've already done the hard work! <a href="https://support.trueimpact.com/how-do-i-clone-a-previous-report">Here's how to clone a previous report.</a></li>
                <li><b>Work smarter, not longer</b> // If you find that you're spending more than 2 hours on this reporting process, reach out at <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>.</li>
                <li><b>Consolidated resources</b>// <a href="https://support.trueimpact.com/social-impact-report-full-training">This resource page</a> includes a recorded training, PPT slides, and example impact receipts (completed reports).</li>
                <li><b>Account access</b> // Are you new here? Here are our resources here on <a href="https://support.trueimpact.com/i-want-to-create-a-new-account">adding yourself to an existing account.</a></li>
                <li><b>People matter</b> // If you don't collect beneficiary data directly, <a href="https://support.trueimpact.com/how-do-i-complete-the-beneficiary-section">this article</a> will help explain how to approach this section using estimates.</li>
                <li><b>Outcomes</b> // You'll find a <a hef="https://support.trueimpact.com/how-do-i-complete-the-outcomes-section">6 min walkthrough</a> of the Outcomes section of the Report Builder here.</li>
                <li><b>Budget</b> // In-kind fields are for monetizing volunteerism and in-kind donations. Your budget section should capture the FULL costs of your program and answer the question, how much does it cost to help people's lives improve? Here is some brief guidance on how to <a href="https://support.trueimpact.com/how-do-i-complete-the-budget-section">complete the Budget Section.</a></li>
                <li><b>Report builder questions</b>// Here's an overview of the <a href="https://www.trueimpact.com/hubfs/Report%20Builder%20Components,%202022.docx">report builder components.</a> However, the logic model is customizable, so it's best to walk through the platform and share the indicators that are a priority to your partners.</li>
                <li><b>Speak to your audience</b> // You'll notice that this reporting process is very different from typical reporting. In most cases, you're selecting from categorical summaries rather than providing long narratives. Think of your Social Impact Report as an Executive Summary or “TED Talk” of your overall program.</li>
            </ul>
        </div>
        </td>
    </tr>
`;

const RULE_8_STATUS_AWAITING_TI_FEEDBACK = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>Dear &lt;donorAccountName&gt; Partners,</p>
        </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>I wanted to send along a quick note to thank you for submitting the following True Impact report for review:</p>
            <ul>
                <li>Organization: &lt;investmentRecipientOrganization&gt;</li>
                <li>Program: &lt;investmentFundedProgramName&gt;</li>
                <li>Investment: $&lt;investmentAmount&gt;</li>
                <li>Account email: &lt;investmentRecipientEmail&gt;</li>
            </ul>
            <br/>
            <p>I'm very much looking forward to reviewing it.</p>
            <p>As I review each report, you will receive an automated email from the True Impact system when your report feedback is ready for review (this email will go to the main TI platform contact). Your feedback will be ready for you to review and resolve feedback, and submit your updated report by &lt;resolveFeedback&gt;. <a href="https://support.trueimpact.com/how-do-i-resolve-feedback-on-my-social-impact-report">This article provides guidance on how to resolve feedback in the True Impact system.</a></p>
            <br/>
            <p>If you have any questions as you receive your feedback, please don't hesitate to reach out to me. </p>
            <p>Best wishes,</p>
            <p><b>The True Impact team</b></p>
            <br/>
            <p>Reporting schedule:</p>
            <ul>
                <li>&lt;submitForFeedback&gt;: Submit your draft report</li>
                <li>Two weeks later, you'll receive feedback from True Impact</li>
                <li>&lt;resolveFeedback&gt;: Publish your updated report to &lt;donorAccountName&gt;</li>
            </ul>
        </div>
        </td>
    </tr>
`;

const RULE_8_STATUS_TI_FEEDBACK_PROVIDED = `<table align="center" border="0" cellpadding="0" cellspacing="0" style="vertical-align: top; max-width: 600px;">
    <tr align='center'>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#000000;font-family:Oxygen, Helvetica neue, sans-serif;font-size:18px;font-weight:700;line-height:23px;text-align:left;'>
            <br/>
            <p><img height="auto" src="https://v3.trueimpact.com/img/logo_primary@2x.png" width="320"/></p>
            <br/>
            <p>Hi &lt;donorAccountName&gt;</p>
            <p style='font-size: 16px;'>Sara Ansell at True Impact reviewed your report and left feedback for you. Please take a few minutes to review as soon as possible so we can finalize your report.</p>
        </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>
                <a style="display:inline-block;background:#0073A3;color:#ffffff;margin:0;text-decoration:none;text-transform:none;padding:10px 25px;mso-padding-alt:0px;border-radius:4px;" target="_blank" href="https://ir.trueimpact.com/?#/login/">Review Feedback</a>
            </p>
            <p><b style="color: #000000;">Due date:</b> &lt;resolveFeedback&gt;</p>
            <p>If you’ve forgotten your password (or if your user account was set up for you and you didn’t receive a password), you can reset it here: <a href="https://ir.trueimpact/#/reset_login">https://ir.trueimpact/#/reset_login</a></p>
            <p style='color:#000000;font-size:18px;font-weight:700;line-height:23px;'>Need help resolving feedback?</p>
            <p>Our incredible Sara Ansell (that’s her smiling face below) of the Client Success team walks you through how to do just that in this video:</p>
            <br/>
            <p><a href='https://www.youtube.com/watch?v=p_5337iOgzc'><img height="auto" src="https://v3.trueimpact.com/img/logo_primary@2x.png" width="320"/></a></p>
            <br/>
            <p style='color:#000000;font-size:12px;'><b>Copyright © <script>document.write(new Date().getFullYear())</script> True Impact. All rights reserved.</b> <a href="https://trueimpact.com/">trueimpact.com</a></p>
            <p style='font-size:12px;'>This message contains important information regarding your account registered at True Impact associated with this email. You may not opt out of transactional emails sent by True Impact. If you are not the intended recipient or have received this email in error, please notify us immediately at support@trueimpact.com and delete this message. <a href="https://ir.trueimpact.com">Learn more</a> about how we protect your information.</p>
        </div>
        </td>
    </tr>
</table>`;

const RULE_8_STATUS_PUBLISHED = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>Dear &lt;investmentFirstName&gt;,</p>
        </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
        <div style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
            <p>Thank you very much for your participation in the reporting process via the True Impact platform. I have received all updated reports and greatly appreciate the time and effort that each of you invested into this process.</p>
            <p>The following True Impact report is now Published:</p>
            <ul>
                <li>Organization: &lt;investmentRecipientOrganization&gt;</li>
                <li>Program: &lt;investmentFundedProgramName&gt;</li>
                <li>Investment: $&lt;investmentAmount&gt;</li>
                <li>Account email: &lt;investmentRecipientEmail&gt;</li>
            </ul>
            <br/>
            <p>If this is an Initial or Interim report, please return to your report at the end of your funding period to change the report stage to Final, and update with final numbers, success stories, and lessons for the future.</p>
            <p>&lt;donorAccountName&gt; can now view your report, and you can share your impacts with other donors, potential funders, your Board, and community stakeholders. <a href="https://support.trueimpact.com/guide-to-understanding-a-social-impact-report">Here is a guide to understanding and sharing your program's impact report</a>. Below, you’ll find an easy-to-use template you can use to share your Social Impact Report so you can build new champions of your important work.</p>
            <p>If you have any questions about the impact reporting process, don't hesitate to get in touch with us at <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>, or access resources at support.trueimpact.com.</p>
            <p>Thank you,</p>
            <p><b>The True Impact team</b></p>
        </div>
        </td>
    </tr>
`;

const RULE_5_STATUS_AWAITING_TI_FEEDBACK = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>Dear &lt;investmentFirstName&gt;,</p>
            </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>There is one week left to submit your draft report in the <a href="https://ir.trueimpact.com/?#/login/">True Impact system</a>. Once you submit your report, I will be able to view it and provide you with feedback. As you'll recall, you'll have an opportunity to strengthen your report after you receive my feedback.</p>
                <p>Please report on your program's anticipated or actual outcomes for the following investment:</p>
                <ul>
                    <li>Organization: &lt;investmentRecipientOrganization&gt;</li>
                    <li>Program: &lt;investmentFundedProgramName&gt;</li>
                    <li>Investment: $&lt;investmentAmount&gt;</li>
                    <li>Account email: &lt;investmentRecipientEmail&gt;</li>
                </ul>
                <br />
                <p>Log into your account at <a href="https://ir.trueimpact.com/?#/login/">https://ir.trueimpact.com/?#/login/</a>, or create a new True Impact reporting account at <a href="https://www.trueimpact.com/signup">www.trueimpact.com/signup</a>. Additional guidance is here <a href="https://support.trueimpact.com/getting-started-with-true-impact">https://support.trueimpact.com/getting-started-with-true-impact</a></p>
                <p>Questions? Don't hesitate to reach out to us at <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>.</p>
                <p>Sincerely,</p>
                <p><b>The True Impact team</b></p>
                <br />
                <p>Reporting schedule:</p>
                <ul>
                    <li>&lt;submitForFeedback&gt;: Submit your draft report</li>
                    <li>Two weeks later, you'll receive feedback from True Impact</li>
                    <li>&lt;resolveFeedback&gt;: Publish your updated report to &lt;donorAccountName&gt;</li>
                    <li>&lt;finalizeReportDate&gt;: Return to your report to set the stage to Final and submit actuals.</li>
                </ul>
                <br/>
                <p><b>Tips + tricks</b></p>
                <ul>
                    <li><b>Report stage</b> // When selecting your report stage, keep in mind:</li>
                    <ul>
                        <li><b>Initial:</b> means you are just starting implementation of your program and will forecast
                            final results</li>
                        <li><b>Interim:</b> means you are already underway implementing your program and will forecast
                            final results </li>
                        <li><b>Final:</b> your program has already finished and you'll be reporting final results</li>
                    </ul>
                    <li><b>Measurement category</b> // Please keep in mind that for all Initial and Interim reports you are *forecasting* your social impacts. These are inherently assumed to be educated guesses/forecasts. When you're asked to select the measurement category, we're asking how you will know the values by the time the report period ends: guess, estimate, or directly measure? Then, it will ask you to briefly tell us more about how you're estimating, or measuring. So if you're guessing a value today but will be able to measure it at the end of the report period, you'd want to select Directly Measured.</li>
                    <li><b>Budget</b> // Please include all expenses for your reporting period, which may include funders beyond &lt;donorAccountName&gt;. This section is meant to capture the full costs to run the program during the reporting period indicated.</li>
                    <li><b>Impact model stages</b> // Recall, only Reach + Succeed are required staged. Program Development, Learn, and Act are optional and should be used if they make sense to your model. Program development means internal efforts such as hiring/training staff, creating new curriculum, purchasing new resources, etc. Note that we recently updated language in the True Impact platform to change “Capacity Developed” to “Program Development” in order to more accurately capture the purpose of the stage. “Capacity Developed” is still noted in all of your training materials, but know that they mean the same thing.</li>
                </ul>
            </div>
        </td>
    </tr>
`;

const RULE_5_STATUS_FINAL = `
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>&lt;investmentFirstName&gt;,</p>
            </div>
        </td>
    </tr>
    <tr>
        <td align='center' style='font-size:0px;padding:10px 25px;word-break:break-word;'>
            <div
                style='color:#777777;font-family:Oxygen, Helvetica neue, sans-serif;font-size:14px;line-height:21px;text-align:left;'>
                <p>It's time to update your social impact report with the final results.</p>
                <br/>
                <p>To finalize your report:</p>
                <ul>
                    <li>Go to True Impact's website at <a href="https://login.trueimpact.com">https://login.trueimpact.com</a> and log in using your email address, &lt;investmentRecipientEmail&gt;</li>
                    <li>Find your report in the "Reports to be Submitted or Published" section, and click the Update button</li>
                    <li>In Overview, change the stage of your report to Final Report</li>
                    <li>In Outcomes, update the Final Results fields, as appropriate</li>
                    <li>In Narratives, complete the Lessons Learned and Success Stories fields</li>
                    <li>In Budget, update the Final Results fields</li>
                </ul>
                <p>Please submit your updates by &lt;finalizeReportDate&gt;.</p>
                <p>You can watch the training and download the training deck here: <a href="https://support.trueimpact.com/i-want-to-update-my-initial-or-interim-report-with-final-results">https://support.trueimpact.com/i-want-to-update-my-initial-or-interim-report-with-final-results</a></p>
                <p>If you have any technical questions, please email us at <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>. If you have questions about your reporting obligations, please contact your &lt;donorAccountName&gt; relationship manager.</p>
                <p>Best wishes,<p>
                <p>The True Impact team</p>
            </div>
        </td>
    </tr>
`;

const RULE_8_TEMPALTES = {
    'DRAFT': RULE_8_STATUS_DRAFT,
    'AWAITING TI FEEDBACK': RULE_8_STATUS_AWAITING_TI_FEEDBACK,
    'TI FEEDBACK PROVIDED': RULE_8_STATUS_TI_FEEDBACK_PROVIDED,
    'PUBLISHED': RULE_8_STATUS_PUBLISHED,
};

const RULE_5_TEMPLATES = {
    'AWAITING TI FEEDBACK':RULE_5_STATUS_AWAITING_TI_FEEDBACK,
    'FINAL': RULE_5_STATUS_FINAL
};

const TITLE_RULE_5_STATUS = {
    'AWAITING TI FEEDBACK': 'Initial <donorAccountName> Report Due tomorrow',
    'FINAL': 'Final True Impact Report Due'
};

const TITLE_RULE_8_STATUS = {
    'DRAFT': 'Thank you and next steps',
    'AWAITING TI FEEDBACK': 'Thank you for submitting your Social Impact Reports',
    'TI FEEDBACK PROVIDED': 'Feedback now available in True Impact for Social Impact Reports',
    'PUBLISHED': 'Sharing gratitude from True Impact'
};

const SUBJECTS = {
    RULE_1: 'Your <donorAccountName> report',
    RULE_3: 'Your <donorAccountName> report',
    RULE_4: 'Stage for <donorAccountName> report was updated',
    RULE_5: 'True Impact Report Due',
    RULE_6: 'Your <donorAccountName> donation was created',
    RULE_7: '<investmentAmount> allocated to <investmentFundedProgramName>',
    RULE_8: 'Your <donorAccountName> report',
    RULE_9: 'Stage for <donorAccountName> report was updated',
    RULE_14: 'Invitation to Social Impact Reporting with True Impact',
};

export const getDefaultSubject = (rule?: number, customStatusRule?: string) => {
    let subject = '';
    if (customStatusRule) {
        switch(rule) {
          case 5:
            subject = TITLE_RULE_5_STATUS?.[customStatusRule];
            break;
          case 8:
              subject = TITLE_RULE_8_STATUS?.[customStatusRule];
            break;
        }
    }
    if (!subject||subject.length===0) {
        subject = SUBJECTS?.[`RULE_${rule}`];
    }
    return subject || '';
};

export const getDefaultTemplate = (rule?: number, customStatusRule?: string) => {
    let template = '';
    if (customStatusRule) {
        switch(rule) {
          case 5:
            template = RULE_5_TEMPLATES?.[customStatusRule];
            break;
          case 8:
              template = RULE_8_TEMPALTES?.[customStatusRule];
            break;
        }
    }
    if (!template||template.length===0) {
        template = TEMPLATES?.[`RULE_${rule}`];
    }
    return template || '';
};